import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbRegisterReq, MbRegisterResp } from 'app/bff/models/mb/mbRegister';
import { ProcessStepCodesEnum } from 'app/features/Member/Register/General/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Register/General/Clauses/types';
import { FormValues as PersonalInfoFormValues } from 'app/features/Member/Register/General/PersonalInfo/types';

// State type
export interface GeneralState {
  process: ProcessState;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  clauses: {
    data?: ClausesFormValues;
  };
  personalInfo: {
    data?: PersonalInfoFormValues;
  };
  confirmInfo: {
    otpAuth: {
      mobile?: AaOtpSendcodeResp;
      email?: AaOtpSendcodeResp;
    }
  },
  complete: {
    referralCode?: MbRegisterResp['ReferralCode'];
  }
}
// ::: End

// Actions type constant
export const MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP = 'MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP';
export const MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA = 'MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA';
export const MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA = 'MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA';
export const MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP = 'MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP';
export const MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE = 'MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE';
export const MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP = 'MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP';
export const MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE = 'MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE';
export const MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP = 'MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP';
export const MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP = 'MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP';
export const MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE = 'MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE';
export const MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP = 'MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP';
export const MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA = 'MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA';
export const MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE = 'MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE';
export const MEMBER_REGISTER_GENERAL__UPDATE_CACHE = 'MEMBER_REGISTER_GENERAL__UPDATE_CACHE';
export const MEMBER_REGISTER_GENERAL__RESET_CACHE = 'MEMBER_REGISTER_GENERAL__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SaveClausesPageDataAction {
  type: typeof MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA;
  payload: {
    data: ClausesFormValues;
  };
}

export interface SavePersonalInfoPageDataAction {
  type: typeof MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA;
  payload: {
    data: PersonalInfoFormValues;
  };
}

export interface SendMobileOTPAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendMobileOTPDoneAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface ResendMobileOTPAction {
  type: typeof MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface ResendMobileOTPDoneAction {
  type: typeof MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthMobileOTPAction {
  type: typeof MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP;
  payload: {
    authMobileOTPArgs: AaOtpVerifyReq;
    sendEmailOTPArgs: AaOtpSendcodeReq;
  };
}

export interface SendEmailOTPAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendEmailOTPDoneAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthEmailOTPAction {
  type: typeof MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP;
  payload: {
    authEmailOTPArgs: AaOtpVerifyReq;
    registerArgs: MbRegisterReq;
  };
}

export interface SendRegisterDataAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA;
  payload: {
    args: MbRegisterReq;
  };
}

export interface SendRegisterDataDoneAction {
  type: typeof MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE;
  payload: {
    response: MbRegisterResp;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_REGISTER_GENERAL__UPDATE_CACHE;
  payload: {
    cache: GeneralState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_REGISTER_GENERAL__RESET_CACHE;
}

export type GeneralActions =
    SetAccessibleStepAction
  | SaveClausesPageDataAction
  | SavePersonalInfoPageDataAction
  | SendMobileOTPAction
  | SendMobileOTPDoneAction
  | ResendMobileOTPAction
  | ResendMobileOTPDoneAction
  | AuthMobileOTPAction
  | SendEmailOTPAction
  | SendEmailOTPDoneAction
  | AuthEmailOTPAction
  | SendRegisterDataAction
  | SendRegisterDataDoneAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
